<template>
  <div>
    <user-portrait
      :centerId="centerId"
      v-if="queryType === 'user' && centerId"
    ></user-portrait>
    <goods-portrait
      :goodId="goodId"
      v-if="queryType === 'goods' && goodId"
    ></goods-portrait>
  </div>
</template>

<script>
import userPortrait from "@/views/portraitLabelMgt/modules/userPortrait";
import goodsPortrait from "@/views/portraitLabelMgt/modules/goodsPortrait";
export default {
  components: {
    userPortrait,
    goodsPortrait
  },
  data() {
    return {
      queryType: "",
      centerId: "",
      goodId: ""
    };
  },
  created() {
    this.queryType = this.$route.query.queryType;
    this.centerId = this.$route.query.centerId;
    this.goodId = this.$route.query.goodId;
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss"></style>
